// Hand over to the installed app by its own address scheme. Done by moving the
// tab, not through a link on the page: the analytics tag reports taps on links
// that lead elsewhere, address and all, and this address can carry the
// person's email.
export const openAppLink = (appAddress: string): void => {
  window.location.href = appAddress;
};
